import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import EventRoute from '../EventRoute';
/**
 * `PrivateRoute` wraps an [EventRoute](#eventroute) and checks if a user is
 * authenticated via the `isAuthenticated` prop. If `isAuthenticated` is
 * `false`, the user will redirect them to the location provided via
 * `redirectLocation`.
 *
 * @public
 * @author Connor Taylor
 */

var PrivateRoute =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(PrivateRoute, _PureComponent);

  function PrivateRoute() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = PrivateRoute.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        isAuthenticated = _this$props.isAuthenticated,
        redirectLocation = _this$props.redirectLocation,
        location = _this$props.location;
    return isAuthenticated ? React.createElement(EventRoute, this.props) : React.createElement(Redirect, {
      to: {
        pathname: redirectLocation,
        state: {
          redirect: this.props.computedMatch.url
        },
        search: location.search
      }
    });
  };

  return PrivateRoute;
}(PureComponent);

PrivateRoute.defaultProps = {
  computedMatch: {},
  isAuthenticated: false,
  redirectLocation: "/login",
  location: {}
};
export default PrivateRoute;